<button
  class="bypass-block-button skip-to-main-content button-reset focus-link"
  tabindex="1"
  (click)="focusOnElement('.router-outlet-container')">
  Jump to content
</button>
